module.exports = __webpack_public_path__ + "img/logo.222232e1.svg";